import makePlainReducer from '../../../creators/reducers/makePlainReducer';

const singleChange = (state, action) => ({
  ...state,
  [action.id]: {
    ...state[action.id],
    ...action.changes,
  },
});

/**
 * Creator function for the data reducer in the pending model. Supports the
 * `CREATE_PENDING_DATA`, `UPDATE_PENDING_DATA`, `DESTROY_PENDING_DATA`, and
 * `REMOVE_TOKEN` action.
 *
 * @param {Object} options The options for the creator
 * @param {Object} options.customConfig Any custom handlers for the reducer
 * @return {Function) The newly created reducer
 *
 * @public
 * @author Connor Taylor
 */
const data = ({ customConfig = {} }) =>
  makePlainReducer({
    config: {
      CREATE_PENDING_DATA: singleChange,
      UPDATE_PENDING_DATA: singleChange,
      DESTROY_PENDING_DATA: (state, action) => {
        const newState = { ...state };
        delete newState[action.id];

        return newState;
      },
      REMOVE_TOKEN: () => ({}),
      ...customConfig,
    },
    initialState: {},
  });

/** @component */
export default data;
